<template lang="pug">
  div
    v-tabs(v-model='active' color="grey lighten-3"  grow )
      v-tab General
      v-tab-item
        General(@generalInfo="generalInfoSave" :dataProduct="product" @productEdited="productEdited"  :updateComponent="update" )
      v-tab Comercial
      v-tab-item
        Comercial(@comercialInfo="comercialInfoSave" :product="gInfo" @productEdited="productEdited" :dataProduct="product1" :updateComponent="update")
      v-tab Inventario
      v-tab-item
        Inventory(@inventoryInfo="inventoryInfoSave" :product="gInfo" :dataProduct="product2" @productEdited="productEdited" :updateComponent="update")
    
    
</template>

<script>
import General from '../showEdit/general/GeneralInformation'
import Comercial from '../showEdit/comercial/ComercialInformation'
import Inventory from '../showEdit/inventory/InventoryInformation'
import ItemModel from '@/models/Warehouse/WhItem'
/* services */
import ProductService from '@/services/api/product'
/* vuex */
import {mapActions} from 'vuex'
export default {
  name: 'create-product-tab-component',
  // props: {},
  data: function(){
    return {
      active: null,
      text: 'asdaddasd',
      gInfo:{},
      gComercial:{},
      gInventory:{},
      model :new ItemModel(),
      product:null,
      update:false,
    }
  },
  computed: {
    tabMenus:[
      {tab:1, info:'GENERAL'},
      {tab:2, info:'COMERCIAL'},
      {tab:3, info:'DESCUENTOS POR CANTIDAD'},
      {tab:4, info: 'INVENTARIO'},
    ]
  },
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    generalInfoSave(event){
      this.gInfo = event
      this.nextTab()
    },
    /*
     */
    comercialInfoSave(event){
      //console.log(event,'comercila event')
      this.gInfo = event
      //this.nextTab()
      this.fetchProduct()
    },
    /**
     *
     */
    inventoryInfoSave(event){
      //console.log(event,'comercila event')
      this.gInfo = event
      //this.nextTab()
      this.fetchProduct()
    },
    // -- Validations and Error handling
    // -- Other functions
    /*
     */
    nextTab () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    /*
     */
    async fetchProduct(){
      let resp = await ProductService.fetchById(this.$route.params.id)
      this.product = resp
      this.product1 = resp.clone()
      this.product2 = resp.clone()
      this.update = false
      
    },
    /*
     */
    productEdited() {
      this.update =true
      this.fetchProduct()
    },

    // -- Vuex mappings
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),
  },
  // watch: {},
  components: {
    General,
    Comercial,
    Inventory,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  mounted(){
    this.fetchProduct()
  },
  beforeMount: function() {
      this.setTitleTopBar('EDICIÓN PRODUCTO')
    },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>